import { SubPlace } from "place/types/place.model";

interface FourWeights {
  correctResult: number;
  aExact: number;
  bExact: number;
  exactMatch: number;
}

interface DistanceCalculation {
  type: string; // "ValueDistance"
  weightsDefinedPoints?: { definiedPoints: number };
}

interface ExactMatchCalculation {
  exactMatchPoints: number;
}

export interface WinConditionPointsCalcConfig {
  winConditionPointsCalcIndex: number;
  type: "FourWeights" | "DistanceCalculation" | "ExactMatch";
  fourWeights?: FourWeights;
  distanceCalc?: DistanceCalculation;
  exactMatchCalc?: ExactMatchCalculation;
}

export interface PronosticV2Winner {
  subPlaceIndex: string; //number to string
  subPlaceTitle?: string; //mandatory to optional
  winner: {
    id: string;
    partitionId: string;
    rank: number;
    name: string;
    phoneNumber: string;
    mail: string;
    totalScore?: number;
    room?: string;
    enterprise?: string;
    predictionString?: string;
  }[]; //single object to array
}

export interface PronosticV2Results {
  pronosticIndex: number;
  field1: number | string;
  field2: number | null;
}
interface WinConditionConfig {
  //both are 1 indexes
  winConditionIndex: number;
  pronosticIndex: number;
  type: "exact" | "closest";
}

export interface PronosticV2Element {
  index: number; // 1 index
  type: "" | "input";
  element1Title: string;
  element2Visual: string;
  element3Title: string;
  element4FieldSize: number;
  element5FieldSize: number;
  element6Title: string;
  element7Visual: string;
}
export interface Player {
  name: string;
  logo: string;
}

export interface SlideShowElement {
  index: number;
  type: "slideshow";
  title: string;
  player: {
    name: string;
    logo: string;
  }[];
  workforceId?: string; // Add workforceId to link to a specific workforce
}

export interface PronosticV2 {
  id: string;
  partitionId: string;
  name: string;
  owner: {
    L1: string;
    L2: string;
    L3: string;
    L4: string;
  };
  parentId: string;
  status: "not started" | "ongoing" | "published" | "closed" | "archived";
  type: string;
  createdAt: string;
  header?: {
    enabled: boolean;
    html: string;
  };
  commonSettings: {
    general: {
      moduleSettings: {
        place: {
          placeId: string;
          placeTitle: string;
          subPlaces: SubPlace[];
        };
        pronostics: (PronosticV2Element | SlideShowElement)[]; //earlier it was PronosticV2Element[]
        winCondition: {
          type: string;
          content: WinConditionConfig[];
          pointsCalc?: WinConditionPointsCalcConfig[];
        };
      };
    };
    webApp: {
      moduleSettings: {
        messageTitleColor: string;
        messageTitleSize: string;
        pronoTitleColor: string;
        pronoTitleSize: string;
        buttonBgColor: string;
        buttonTextColor: string;
        mandatoryTextColor: string;
        mandatoryTextSize: string;
        rankingPageTitleColor?: string;
        rankingPageTitleSize?: string;
        rankingPageBorderColor?: string;
        backGroundPosition?: string;
      };
      medias: {
        backGroundImage: string;
      };
      texts: {
        welcomeMessage: string;
        footerMessage: string;
        thankYouMessage: string;
        noResultMessage: string;
        notStartedMessage: string;
        tooLateMessage: string;
        mandatoryMessage: string;
        submitButtonLabel: string;
        backHomeButtonLabel: string;
        resultsButtonLabel: string;
        refreshButtonLabel: string;
        subPlacePrefixTitle?: string;
        rankingPageTitle?: string;
      };
    };
    publicSharing: {
      moduleSettings: {
        messagesColor: string;
        messagesSize: string;
        screenTopMargin: string;
        screenLeftMargin: string;
      };
      medias: {
        backgroundImage: string;
        sponsorImage: string;
      };
      texts: {
        introductionMessage: string;
      };
    };
  };
  specificSettings: {
    beginAt: string;
    endAt: string;
    pronosticResults: PronosticV2Results[];
    resultsPublication: boolean;
    winnersInfo: PronosticV2Winner[];
  };
}

// Simple helper function to check if element is an input-like element
export function isInputLikeElement(
  element: PronosticV2Element | SlideShowElement
): element is PronosticV2Element {
  return element.type === "input" || element.type === "";
}
